module.exports = __webpack_public_path__ + "img/exit-icon.e1951df1.svg";